



















































































  import { Component, Prop, Vue } from 'vue-property-decorator'
  import InputCommon from '@/components/lib/InputCommon.vue'
  import ButtonCommon from '@/components/lib/ButtonCommon.vue'
  import CheckboxCommon from '@/components/lib/CheckboxCommon.vue'
  import {
    CONTACT_VALUE_MAX_LENGTH,
    CUSTOMER_FIRST_NAME_MAX_LENGTH,
    CUSTOMER_EMAIL_MAX_LENGTH,
    ICustomerExtendData,
    ITravel
  } from '@/entities'
  import { Theme } from "@/store";
  import { RawLocation } from 'vue-router'
  import { closeAndMove } from "@/lib";
import { isEqual } from 'lodash'

  @Component({
    components: {
      InputCommon,
      ButtonCommon,
      CheckboxCommon
    },
  })
  export default class FormContent extends Vue {
    @Prop() innerColorCondition!: boolean;
    @Prop() labelCondition!: boolean;
    @Prop() diasbleCancelButton!: boolean;

    @Prop() readonly value!: ICustomerExtendData
    @Prop() readonly result?: string
    @Prop() readonly resultClass?: string
    @Prop({ default: false }) readonly policy!: boolean
    @Prop({ default: false }) readonly noSubmit?: boolean
    @Prop({ default: false }) readonly noResult?: boolean
    @Prop() readonly theme?: Theme

    isCancelButtonActive = false;

    mounted() {
      if (isEqual(this.$route.path, '/travels') && this.diasbleCancelButton
          || this.$route.params.id && this.labelCondition) {
        this.isCancelButtonActive = true;
      }
    }

    get currentTravel(): ITravel {
      return this.$store.getters.getGroupTravel;
    }

    get acceptPolicy(): boolean {
      return this.policy;
    }
    set acceptPolicy(value: boolean) {
      this.$emit('update:policy', value);
    }

    private submit(): void {
      // if (this.value.phone?.match(/^[0-9\\s+\\-\\.]+$/)
      //     && this.value.email?.match(/^([a-z0-9_-]+\.)*[a-z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)*\.[a-z]{1,6}$/)
      //     && this.value.first_name) { }

      this.$emit('submit');
    }

    get CONTACT_VALUE_MAX_LENGTH(): number {
      return CONTACT_VALUE_MAX_LENGTH;
    }
    get CUSTOMER_FIRST_NAME_MAX_LENGTH(): number {
      return CUSTOMER_FIRST_NAME_MAX_LENGTH;
    }
    get CUSTOMER_EMAIL_MAX_LENGTH(): number {
      return CUSTOMER_EMAIL_MAX_LENGTH;
    }

    private closeAndMove(to: RawLocation): void {
      closeAndMove(this, to);
    }

    private closeModal(): void {
      this.$store.dispatch('setEmailModalCondition', false);
    }
  }
